var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderbolttwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "21.59 8 15.87 8 19.87 2 7.32 2 2.52 14 8.61 14 5.84 22.31 21.59 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolttwo);
export default __webpack_public_path__ + "static/media/thunderbolttwo.b5b94b6216a3d2ce23961930f45445dd.svg";
export { ForwardRef as ReactComponent };